import type { ReactNode } from "react";

import type { CountryCode } from "@/constants/country";
import { cn } from "@/lib/cn";

import { CountryFlag } from "./CountryFlag";

export interface CountryFlagWithLabelProps {
  /** ISO 3166-1 alpha-2 形式の国コード */
  // oxlint-disable-next-line typescript/no-redundant-type-constituents -- 未知の国コードも受け入れる
  countryCode?: CountryCode | string | null;
  /** 表示するラベル（国名など） */
  label: ReactNode;
  /** コンテナの追加クラス名 */
  className?: string;
  /** 国旗の追加クラス名 */
  flagClassName?: string;
  /** ラベルの追加クラス名 */
  labelClassName?: string;
}

/**
 * 国旗とラベルを表示するコンポーネント
 *
 * @example
 * ```tsx
 * <CountryFlagWithLabel countryCode="JP" label="日本" />
 * <CountryFlagWithLabel countryCode="US" label="アメリカ合衆国" className="gap-3" />
 * ```
 */
export const CountryFlagWithLabel = ({
  countryCode,
  label,
  className,
  flagClassName,
  labelClassName,
}: CountryFlagWithLabelProps) => {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      {countryCode && (
        <CountryFlag countryCode={countryCode} className={flagClassName} />
      )}
      <span className={labelClassName}>{label}</span>
    </div>
  );
};
